import type { Tip } from '../types';
import { Mascot } from './mascots';
import { useLanguage } from '../i18n/context';
import { CollapsibleItems, DetailDisclosure, ExpandableText } from './Expandable';
import styles from '../App.module.css';

interface TipsProps {
  items: Tip[];
}

function fallbackDetail(title: string, body: string, locale: string): string {
  if (locale === 'en') {
    return `${body} Tip: write one next action under “${title}” and share it with your partner so help is concrete.`;
  }
  if (locale === 'zh') {
    return `${body} 建议：围绕「${title}」写下下一步，并告诉家人具体怎么帮忙。`;
  }
  return `${body} ヒント「${title}」は、次にやることを1つメモして家族に共有すると進みやすいです。新潟市の制度や窓口が関係する場合は、母子モや市の子育てページもあわせて確認を。`;
}

export function Tips({ items }: TipsProps) {
  const { locale } = useLanguage();

  return (
    <CollapsibleItems total={items.length} initial={3}>
      {(visible) => (
        <div className={styles.tipsGrid}>
          {items.slice(0, visible).map((tip) => (
            <div key={tip.id} className={styles.tipCard}>
              <div className={styles.tipHeader}>
                <Mascot id="star" size={26} />
                <h4 className={styles.tipTitle}>{tip.title}</h4>
              </div>
              <ExpandableText text={tip.body} limit={60} className={styles.tipBody} />
              <DetailDisclosure detail={tip.detail || fallbackDetail(tip.title, tip.body, locale)} />
            </div>
          ))}
        </div>
      )}
    </CollapsibleItems>
  );
}
